module.exports = __webpack_public_path__ + "static/media/26.f7d16254.jpg";